import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useDownloadStats = () =>
  useStore(store => store.getDownloadStats.state)
